import { Stack, styled } from "@mui/material";
import ButtonBase from "Components/button/BaseButton";
import SmText from "Components/text/SmText";
import { COLORS } from "constants/layout";
import { useTranslation } from "hooks/useTranslation";

type Props = {
  value?: string;
  onChange?: (value: string) => void;
};

const SortChip = ({ value, onChange }: Props) => {
  const t = useTranslation();

  const options = [
    // { label: "recommend_for_you", value: "best" },
    { label: "hot", value: "hot" },
    { label: "new", value: "new" },
    // { label: "reviews", value: "review" },
  ];

  return (
    <StyledStack
      direction="row"
      alignItems="center"
      gap={{ xs: 0.5, md: 1 }}
      flexWrap="wrap"
    >
      <SmText>{t("sort_by")}</SmText>
      {options.map((option) => (
        <ButtonBase
          key={option.value}
          onClick={() => onChange?.(option.value)}
          className={value === option.value ? "selected" : ""}
        >
          {t(option.label)}
        </ButtonBase>
      ))}
    </StyledStack>
  );
};

const StyledStack = styled(Stack)(({ theme }) => ({
  button: {
    padding: "6px 10px",
    height: 32,
    borderRadius: 4,
    backgroundColor: "#fff",
    color: COLORS.green[600],
    fontWeight: 400,
    border: `1px solid ${COLORS.gray[100]}`,
    "&.selected": {
      backgroundColor: COLORS.green[600],
      color: "#fff",
    },
  },
  [theme.breakpoints.down("md")]: {
    button: {
      padding: "4px 8px",
      height: 26,
      fontSize: 12,
    },
  },
}));

export default SortChip;
